import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ConsumptionInsightsDto } from "../dto/proposal-consumption.dto"
import { proposalConsumptionService } from "../services/proposal-consumption.service"

export default function useProposalConsumptionInsights(
  proposalId: string,
  options?: { enabled?: boolean; importId?: string | null },
): UseQueryResult<ConsumptionInsightsDto, unknown> {
  return useQuery({
    queryKey: queryKeys.proposalConsumption.insightsForImport(
      proposalId,
      options?.importId ?? null,
    ),
    queryFn: () => proposalConsumptionService.getInsights(proposalId),
    enabled: !!proposalId && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
